/**
 * SN-8299 — the line under a preference's sport: how many competitions it is
 * saved for (one copy each). Deliberately not "active in" — a saved copy says
 * nothing about being findable: the player's Player Finder switch can be off.
 */
export const savedForCompetitionsLabel = (count: number): string =>
  `Saved for ${count} ${count === 1 ? 'competition' : 'competitions'}`
